import { ProgressStatus } from 'src/types/progress.type';

export function statusToChip(status: ProgressStatus | null | undefined) {
    if (status === 'PENDING') return { text: 'Submitted (Pending)', cls: 'bg-amber-100 text-amber-700' };
    if (status === 'APPROVED' || status === 'AUTO_APPROVED')
        return { text: 'Approved', cls: 'bg-green-100 text-green-700' };
    if (status === 'REJECTED') return { text: 'Rejected', cls: 'bg-rose-100 text-rose-700' };
    return { text: 'Not submitted', cls: 'bg-gray-100 text-gray-600' };
}

export default function WbsProgressChip({ status }: { status: ProgressStatus | null | undefined }) {
    const { text, cls } = statusToChip(status);
    return (
        <span className={`inline-flex items-center gap-1 rounded-lg px-2 py-0.5 text-xs ${cls}`}>
            <i className="w-1.5 h-1.5 rounded-full bg-current" />
            {text}
        </span>
    );
}
